export enum CurrentForm {
  REQUEST_CODE = 'LoginFormRequestCode',
  CONFIRM_CODE = 'LoginFormConfirmCode',
  SET_NAME = 'LoginFormSetName',
  SIGN_IN = 'LoginFormSignIn',
}

export interface LoginState {
  phone: string
  currentForm: CurrentForm
  actions: {
    requestCode: RequestCodeState
  }
}

export interface RequestCodeState {
  disabled: boolean
  timer: number
  inProgress: boolean
}

export interface OptionsPhone {
  mask: string
  placeholder: string
  code: number
  length: number
}

export enum DeliveryType {
  SMS = 'sms',
  CALL = 'call',
  FLASH_CALL = 'flash_call',
}
